<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('project.title')" :showTitle="false"></page-title>
            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="redirectToList">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('project.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row float-bott">
                        <div class="form-group col-4">
                            <label :for="'number' + _uid" class="font-weight-bold">{{ $t('project.number') }}</label>
                            <input type="number"
                                   class="form-control"
                                   v-model="project.number"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'contract' + _uid" class="font-weight-bold">{{ $t('project.contract') }}</label>
                            <input type="text"
                                   class="form-control"
                                   v-model="project.contract"
                                   readonly />
                        </div>
                        <div class="form-group col-4">
                            <label :for="'funding' + _uid" class="font-weight-bold">{{ $t('project.funding') }}</label>
                            <input type="text" class="form-control" v-model="project.fundingType" readonly />
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label :for="'name' + _uid" class="font-weight-bold">{{ $t('project.name') }}</label>
                            <textarea type="text"
                                      class="form-control"
                                      v-model="project.name"
                                      readonly />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('project.partners') }}</div>
                </div>
                <div v-for="(organizer,index) in project.organizers" :key="index">
                    <div class="card-body">
                        <div class=" form-control">
                            <label :for="'name' + _uid" class="font-weight-bold">{{ $t('project.partner') }}</label>
                        </div>
                        <div class="row">
                            <div class="card-body col-4">
                                <label :for="'name' + _uid" class="font-weight-bold">{{ $t('project.partner') }}</label>
                                <input type="text" class="form-control" v-model="organizer.organizer" readonly />
                            </div>
                            <div class="card-body col-8">
                                <div v-if="organizer.organizer">
                                    <label :for="'name' + _uid" class="font-weight-bold">{{ $t('project.partnerContract') }}</label>
                                    <input type="text" class="form-control" v-model="organizer.organizerContract" readonly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('project.activities') }}</div>
                </div>
                <div v-for="(activity,index) in project.activities" :key="index">
                    <div class="card-body">
                        <div class="form-control">
                            <label :for="'name' + _uid" class="font-weight-bold">{{ $t('project.activity') }}</label>
                        </div>
                        <div class="mt-2">
                            <input type="text" class="form-control" v-model="activity.activity" readonly />
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('project.projectActivities') }}</div>
            </div>
            <div class="card-body">
                <div v-for="(projectActivity,index) in project.projectActivities" :key="index">
                    <div class="form-control">
                        <label :for="'projectActivity' + _uid" class="font-weight-bold mt-2">{{ $t('project.projectActivity') }}</label>
                    </div>
                    <input type="text"
                           class="form-control mt-3"
                           v-model="project.projectActivities[index]"
                           readonly/>
                </div>
            </div>
        </div>
        <div class="card mt-3">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{ $t('otherFields.otherFields') }}</div>
            </div>
            <div class="card-body">
                <otherFields :otherFields="project.otherFields"></otherFields>
            </div>
        </div>
        <div class="mt-3" v-if="project">
            <AuxiliaryRegisterDetails :entryId="project.auxRegisterEntityId"></AuxiliaryRegisterDetails>
        </div>
    </div>
</template>

<script>
    import OtherFields from '../../../components/otherFields/OtherFieldsDetails.vue';
    import PageTitle from '../../../components/common/PageTitle';
    import { ProjectDetails } from '../../../models/models';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            PageTitle,
            OtherFields,
            AuxiliaryRegisterDetails
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                project: new ProjectDetails(),
                loading: false,
            }
        },
        methods: {
            redirectToList() {
                this.$router.push(this.returnUrl || '/registers/projects');
            },
            load() {
                this.loading = true;
                this.$http.get(`/api/projects/GetDetails/${this.id}`).then(result => {
                    this.project = new ProjectDetails(result.data);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style scoped>
     input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
